import { render, staticRenderFns } from "./invoice-3.vue?vue&type=template&id=5572e6e3&"
import script from "./invoice-3.vue?vue&type=script&lang=js&"
export * from "./invoice-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports